import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-clock-rewind',
  imports: [],
  templateUrl: './clock-rewind.html',
  styleUrl: './clock-rewind.scss',
})
export class ClockRewind {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
